// extracted by mini-css-extract-plugin
export default {"banner":"About_banner__Y5A6z","h2":"About_h2__NaFnx","texte":"About_texte__Fr4XV","n1":"About_n1__rRRo-","video":"About_video__ngmzD","arrow2":"About_arrow2__IhOXD"};